import React, { useState, useEffect } from 'react';
import { CronDescription } from '../../CronDescription';
import { CommentSection } from 'components/JobComments';
import Autocomplete from '@mui/material/Autocomplete';
import {
  getAvailable1PasswordFields,
  getAvailable1PasswordItems
} from '_services/ApiService';
import { TextField } from '@mui/material';
import { useJobsContext } from 'components/JobList';

export const Comment = (jobId) => ({ value, onChange }) => {
  const { readonly } = useJobsContext();
  return (
    <CommentSection
      jobId={jobId}
      onChange={onChange}
      readonly={readonly}
      value={value}
    />
  );
};

export const Schedule = (props) => {
  const Text = props.registry.widgets.TextWidget;
  return (
    <Text {...props} helperText={<CronDescription value={props.value} />} />
  );
};

// Autocomplete over the available 1Password paths, wired to the rjsf form data. Paths can also
// be typed in, for items the list doesn't show.
const OnePasswordChooser = ({ fetchOptions, value, onChange, disabled, readonly, id }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    async function fetchSecrets() {
      const opts = await fetchOptions();
      setOptions(opts.sort());
    }
    fetchSecrets();
  }, [fetchOptions]);

  const save = (newValue) => onChange(newValue ? newValue : undefined);

  return (
    <Autocomplete
      disabled={disabled || readonly}
      freeSolo
      id={id}
      onChange={(event, newValue) => save(newValue)}
      onInputChange={(event, newValue, reason) => {
        if (reason === 'input') {
          save(newValue);
        }
      }}
      options={options}
      renderInput={(params) => (
        <TextField {...params} label="Path to secret" variant="outlined" />
      )}
      value={value ?? null}
    />
  );
};

export const OnePasswordItemChooser = (props) => (
  <OnePasswordChooser {...props} fetchOptions={getAvailable1PasswordItems} />
);

export const OnePasswordFieldChooser = (props) => (
  <OnePasswordChooser {...props} fetchOptions={getAvailable1PasswordFields} />
);
